import { getExclusionList } from './getExclusionList'
import { filterPitchTypeFacets } from '../utils/isPitchTypeFacet'

export function excludeQueryParams({
  excludeType,
  forceQueryParams,
  query,
  excludeQueryParams,
  language = 'en-gb',
}: {
  excludeType?: string
  forceQueryParams?: string[]
  query: Record<string, any>
  excludeQueryParams?: string[]
  language?: string
}): Record<string, any> {
  const outQuery = { ...query }
  const exclusionList = getExclusionList(excludeType).concat(
    getExclusionList('alwaysExcluded'),
  )

  exclusionList.forEach((key) => {
    if (!forceQueryParams?.includes(key)) {
      delete outQuery[key]
    }
  })

  excludeQueryParams?.forEach((param) => {
    if (!forceQueryParams?.includes(param)) {
      delete outQuery[param]
    }
  })

  // For homepage navigation, only preserve category pitch type facets
  // (tent, motorhome, etc.) and remove facility/feature facets (electric, wifi, etc.)
  if (
    (excludeType === 'homepage' || excludeType === 'homepageLink') &&
    outQuery.facet
  ) {
    outQuery.facet = filterPitchTypeFacets(outQuery.facet, language)
  }

  return outQuery
}
